export default "__VITE_ASSET__78a879cd__"